module.exports = __webpack_public_path__ + "img/1698343544058.306581d9.jpg";